export default __webpack_public_path__ + "static/Storm-Cleanup-9d287384eca471a690286b06537c04fa.jpg";